import React from "react";
import { SourceProvider } from "./sourceContext";
import { ControlProvider } from "./controlContext";
import { ControlWrapperProvider } from "./controlWrapperContext";
import { SchemaProvider } from "./schemaContext";

export function ControlManagerContexts({ childContainerRef, children, source, content, options, objectMetadata, onChange, schemas, onSubmit}) {
  return (
    <SchemaProvider data={schemas}>
      <SourceProvider data={source} onChange={(src, cb) => onChange('source', src, cb)}>
        <ControlProvider data={content} onChange={(ctrl, cb) => onChange('controls', ctrl, cb)}>
          <ControlWrapperProvider childContainerRef={childContainerRef} options={options} objectMetadata={objectMetadata} onSubmit={onSubmit} >
            {children}
          </ControlWrapperProvider>
        </ControlProvider>
      </SourceProvider>
    </SchemaProvider>

  )
}